import React, { useState } from "react";
import "../../iqac.css";
import TopNav from "../../../../../Components/TopNav";
import Navbar from "../../../../../Components/Navbar";
import DropdownNav from "../../../../../Components/DropdownNav";
import Footer from "../../../../../Components/Footer";
import Example from "../../../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const NAACCertificate = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="naacc-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className="iqac-obj-tit">NAAC Certificate</h1>
        </div>
      </div>

      <div className="iqac-obj-det">
        <button
          onClick={() => setIsOpen((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          NAAC Certificate Details
        </button>
        {isOpen && (
          <div className="ssr-items">
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/images/FIRST%20CYCLE.jpg"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>
                    1 <br></br>
                    NAAC 1 st Cycle
                  </h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/images/Second%20CYCLE.jpg"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>
                    2<br></br>
                    NAAC 2 nd Cycle
                  </h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/pdf/Certificate%20-%20NAAC-3rd%20cycle.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>
                    3 <br></br>
                    NAAC 3 rd Cycle
                  </h3>
                </a>
              </div>
            </div>
            {/* This is the starting node of AQARREPORTS */}
            <div>
              <div className="aqar-items">
                <a
                  href="https://thenewcollege.edu.in/pdf/NAAC4thcycle.pdf"
                  target="new"
                >
                  <img
                    src="https://sedge.in/New%20College/assest/logo.png"
                    className="ssr-image"
                  />
                  <h3>
                    4 <br></br>
                    NAAC 4 th Cycle
                  </h3>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default NAACCertificate;
